import PromptBookVote from "components/prompts/PromptBookVote";
import {
  LetterbookPromptType,
} from "features/Letterbooks/types";
import LetterbooksBookRow from "../shared/LetterbooksBookRow";

export default function LetterbookPromptRow({
  letterbook,
}: {
  letterbook: LetterbookPromptType;
}) {
  const { data } = letterbook;

  return (
    <div
      className={`flex flex-row space-x-2 max-w-screen py-4 border-b border-gray-300 dark:border-gray-700`}
    >
      <PromptBookVote promptBook={data.promptBook} />
      <LetterbooksBookRow
        book={letterbook.book}
        size="sm"
        settings={{
          linkContributions: true,
        }}
      />
    </div>
  );
}
